export default __webpack_public_path__ + "static/media/stayUp3.1bec65f9.png";